export default "__VITE_ASSET__N_RHt6AV__"